module.exports = __webpack_public_path__ + "img/edit.e5894fea.svg";